import styled from "@emotion/styled";

import { LiveArticleContentItem } from "./item";

export const Container = styled.div``;

export const StyledLiveArticleContentItem = styled(LiveArticleContentItem)`
  margin-block-start: 32px;
`;

export const AdSlotContainer = styled.div`
  display: none;

  margin-block-start: 32px;

  ${props => props.theme.breakpoints.down("desktop")} {
    display: block;
  }
`;
